export const reporterStats = {
  totalArticles: 18,
  pendingReview: 5,
  publishedArticles: 11,
  rejectedArticles: 2,
};

export const reporterProfile = {
  id: 1,
  name: 'Anil Sharma',
  email: 'anil.sharma@example.com',
  role: 'reporter',
  avatar: null,
  phone: '9845671234',
  joinedDate: '2026-01-15',
  totalArticles: 18,
  specialization: 'Good Governance, Infrastructure',
  bio: 'Senior reporter covering urban development and governance.',
};

export const reporterArticles = [
  {
    id: 1,
    title: 'भिजन २०५० शुभारम्भ कार्यक्रम सम्पन्न',
    category: 'Events',
    sector: 'Good Governance',
    status: 'pending',
    submittedDate: '2026-07-15',
    updatedDate: '2026-07-16',
    summary: 'Vision 2050 campaign officially launched at Itahari Sub-Metropolitan City Hall with civic leaders and citizens.',
    adminRemark: null,
    tags: ['vision2050', 'launch', 'governance'],
  },
  {
    id: 2,
    title: 'नागरिक सुझाव संकलन अभियान सुरु',
    category: 'Public Participation',
    sector: 'Citizen Engagement',
    status: 'published',
    submittedDate: '2026-07-10',
    updatedDate: '2026-07-12',
    summary: 'Citizen suggestion collection drive begins across all 21 sectors.',
    adminRemark: null,
    tags: ['suggestion', 'citizen', 'participation'],
  },
  {
    id: 3,
    title: 'इटहरीमा हरित पार्क निर्माण सुरु',
    category: 'Development',
    sector: 'Environment & Sustainability',
    status: 'approved',
    submittedDate: '2026-07-08',
    updatedDate: '2026-07-09',
    summary: 'Construction of a green park in Itahari begins as part of the Vision 2050 plan.',
    adminRemark: null,
    tags: ['green', 'park', 'environment'],
  },
  {
    id: 4,
    title: 'स्थानीय तह निर्वाचन तयारी समिति गठन',
    category: 'Politics',
    sector: 'Good Governance',
    status: 'rejected',
    submittedDate: '2026-07-05',
    updatedDate: '2026-07-07',
    summary: 'Local election preparation committee formed in Itahari.',
    adminRemark: 'Please verify the facts with the municipal office. The committee formation date is incorrect.',
    tags: ['election', 'local', 'committee'],
  },
  {
    id: 5,
    title: 'युवा उद्यमशीलता कार्यक्रम सफल',
    category: 'Development',
    sector: 'Economic Development & Employment',
    status: 'draft',
    submittedDate: '2026-07-14',
    updatedDate: '2026-07-14',
    summary: 'Youth entrepreneurship program successfully concluded with 50 participants.',
    adminRemark: null,
    tags: ['youth', 'entrepreneurship', 'program'],
  },
  {
    id: 6,
    title: 'इटहरीमा नयाँ विद्यालय भवन उद्घाटन',
    category: 'Education',
    sector: 'Education & Skill Development',
    status: 'pending',
    submittedDate: '2026-07-13',
    updatedDate: '2026-07-14',
    summary: 'New school building inaugurated in Itahari with modern facilities.',
    adminRemark: null,
    tags: ['education', 'school', 'infrastructure'],
  },
];

export const assignedEvents = [
  {
    id: 1,
    title: 'Vision 2050 Launch Program',
    date: '2026-07-15',
    location: 'Itahari Sub-Metropolitan City Hall',
    status: 'upcoming',
    deadline: '2026-07-16',
    description: 'Official launch of the Bholiko Itahari Vision 2050 campaign with city officials and stakeholders.',
    coverageSubmitted: false,
  },
  {
    id: 2,
    title: 'Ward Level Citizen Consultation',
    date: '2026-07-20',
    location: 'Ward No. 5 Community Hall',
    status: 'upcoming',
    deadline: '2026-07-21',
    description: 'Citizen consultation meeting for ward-level development priorities.',
    coverageSubmitted: false,
  },
  {
    id: 3,
    title: 'Green Itahari Plantation Drive',
    date: '2026-07-10',
    location: 'Itahari Riverside Area',
    status: 'completed',
    deadline: '2026-07-12',
    description: 'Massive plantation drive along the riverbank with 2000+ saplings.',
    coverageSubmitted: false,
  },
  {
    id: 4,
    title: 'Infrastructure Development Review',
    date: '2026-07-25',
    location: 'Municipal Office Conference Hall',
    status: 'upcoming',
    deadline: '2026-07-26',
    description: 'Quarterly review of infrastructure projects under Vision 2050.',
    coverageSubmitted: false,
  },
];

export const reporterMedia = [
  {
    id: 1,
    image: null,
    caption: 'Vision 2050 launch event main stage',
    relatedEvent: 'Vision 2050 Launch Program',
    uploadDate: '2026-07-15',
    status: 'pending',
    type: 'image',
  },
  {
    id: 2,
    image: null,
    caption: 'Citizens participating in consultation',
    relatedEvent: 'Ward Level Citizen Consultation',
    uploadDate: '2026-07-12',
    status: 'approved',
    type: 'image',
  },
  {
    id: 3,
    image: null,
    caption: 'Plantation drive group photo',
    relatedEvent: 'Green Itahari Plantation Drive',
    uploadDate: '2026-07-10',
    status: 'approved',
    type: 'image',
  },
  {
    id: 4,
    image: null,
    caption: 'Infrastructure site visit footage',
    relatedEvent: 'Infrastructure Development Review',
    uploadDate: '2026-07-14',
    status: 'rejected',
    type: 'video',
  },
];

export const dashboardNotifications = [
  { id: 1, message: 'Article "भिजन २०५० शुभारम्भ" is pending review', type: 'info', time: '2 hours ago' },
  { id: 2, message: 'Media upload approved for plantation drive', type: 'success', time: '5 hours ago' },
  { id: 3, message: 'Article "स्थानीय तह निर्वाचन" was rejected. Please check admin remarks.', type: 'error', time: '1 day ago' },
];
